import React from 'react';

export default function MobileSimulator() {
  return (
    <div className="min-h-screen bg-[#2C2C2C] flex items-center justify-center py-8">
      <div className="text-center absolute top-8 text-white/50">
        <h1 className="font-serif text-2xl mb-2">Simulateur Mobile</h1>
        <p className="text-sm font-light">Testez l'expérience exacte de vos invités et de vous-même sur téléphone.</p>
      </div>
      
      {/* Phone Frame */}
      <div className="relative w-[375px] h-[812px] bg-black rounded-[50px] shadow-2xl overflow-hidden border-[8px] border-black ring-1 ring-white/20">
        {/* Notch */}
        <div className="absolute top-0 inset-x-0 h-6 bg-black z-50 rounded-b-3xl mx-auto w-40"></div>
        
        {/* Iframe pointing to the app */}
        <iframe 
          src="/app" 
          className="w-full h-full bg-white"
          title="Mobile App Simulator"
        />
      </div>
    </div>
  );
}
